import React from 'react';



export default function CreateCompany(props) {
    return (
        <div>Form here</div>
    )
}


function CreateCompanyForm() {
 
}



// WEBPACK FOOTER //
// ./src/components/newCompany.js